import { useQuery } from '@tanstack/react-query';
import indexFundsService from "@indexFundsService";

export function useFetchIndexFundPrice(fundSymbol: string): {
  data: IndexFundPrice | null;
  isLoading: boolean;
  error: Error | null;
} {
  return useQuery({
    queryKey: ['index-fund-price', fundSymbol],
    queryFn: async () => {
      return await indexFundsService.fetchIndexPrice(fundSymbol);
    },
    enabled: !!fundSymbol,
    staleTime: 5 * 60 * 1000, // 5 min cache
    retry: 3,
    retryDelay: (attempt) => Math.min(1000 * Math.pow(2, attempt), 30000),
  });
}
